module.exports = __webpack_public_path__ + "static/media/calenderIcon.6708da29.svg";